// The Activity page (SignInPage): its route, the id of its tab strip and the
// derived URL param (`${id}-tab`, tabs.utils), and the tab values other
// surfaces deep-link to. Defined once so a link into "Activity, on the Trials
// tab" is built here and never re-spelled.

export const ACTIVITY_PATH = "/activity"
export const ACTIVITY_TABS_ID = "sign-ins"
export const ACTIVITY_TAB_PARAM = `${ACTIVITY_TABS_ID}-tab`

export const ACTIVITY_VIEW_PORTFOLIO = "portfolio"
export const ACTIVITY_VIEW_TRIALS = "trials"
export const ACTIVITY_VIEW_USERS = "users"
export const ACTIVITY_VIEW_USAGE = "usage"
export const ACTIVITY_VIEW_REFUSALS = "refusals"
export const ACTIVITY_VIEW_SESSIONS = "sessions"
export const ACTIVITY_VIEW_EVENTS = "events"

export type ActivityView =
  | typeof ACTIVITY_VIEW_PORTFOLIO
  | typeof ACTIVITY_VIEW_TRIALS
  | typeof ACTIVITY_VIEW_USERS
  | typeof ACTIVITY_VIEW_USAGE
  | typeof ACTIVITY_VIEW_REFUSALS
  | typeof ACTIVITY_VIEW_SESSIONS
  | typeof ACTIVITY_VIEW_EVENTS

/** Absolute href opening the Activity page on one of its tabs. */
export function buildActivityLink(view: ActivityView) {
  return view === ACTIVITY_VIEW_USERS
    ? ACTIVITY_PATH
    : `${ACTIVITY_PATH}?${ACTIVITY_TAB_PARAM}=${view}`
}
